import { reactive } from 'vue';
import { useBreakpoints } from '@vueuse/core';
import breakpointJson from '@/assets/json/breakpoint.json';

const breakpoint = useBreakpoints(breakpointJson);
const current = breakpoint.current();
const xs = breakpoint.smaller('sm');
const xse = breakpoint.smallerOrEqual('sm');
const sm = breakpoint.between('sm', 'md');
const md = breakpoint.between('md', 'lg');
const lg = breakpoint.between('lg', 'xl');
const xl = breakpoint.between('xl', '2xl');
const xxl = breakpoint['2xl'];

const breakpoints = reactive({
  current,
  xs,
  xse,
  sm,
  md,
  lg,
  xl,
  xxl
});

export { breakpoints };

